import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { archiveAdminCompany, fetchAdminCompaniesList, type ArchiveCompanyBody } from '@/api/admin-companies.api'
import { useToast } from '@/app/context/toast-provider'
import { adminCompaniesQueryKeys } from '@/constants/cache-keys.contant'

export const useAdminCompaniesListQuery = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: adminCompaniesQueryKeys.list(),
        queryFn: fetchAdminCompaniesList,
        enabled: options?.enabled !== false,
        staleTime: 0,
    })
}

export const useArchiveAdminCompanyMutation = () => {
    const queryClient = useQueryClient()
    const { showSuccessToast, showErrorToast } = useToast()

    return useMutation({
        mutationFn: ({ companyId, body }: { companyId: number; body: ArchiveCompanyBody; disableToast?: boolean }) => archiveAdminCompany(companyId, body),
        onSuccess: (_, variables) => {
            void queryClient.invalidateQueries({ queryKey: adminCompaniesQueryKeys.all })
            if (variables.disableToast) return
            showSuccessToast(variables.body.archived ? 'Organization archived successfully' : 'Organization restored successfully')
        },
        onError: (error: Error, variables) => {
            if (variables.disableToast) return
            showErrorToast(error.message || 'Failed to update organization archive status')
        },
    })
}
